export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID!;
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN!;

export const CORE_LOAD_BALANCER_URL =
  process.env.REACT_APP_CORE_LOAD_BALANCER_URL! + "api/v1";
export const YEH_ASSOCIATION_LOAD_BALANCER_URL = process.env
  .REACT_APP_YEH_ASSOCIATION_LOAD_BALANCER_URL!;
